import { Service } from "../shared/Service";

export class AreaAtuacaoService extends Service{

  constructor(){
    super('areaAtuacao');
  }

}